import React from 'react';
import { SvgDownload } from '@grubhubprod/gh-cookbook-react';
import { DataTable } from 'src/components/DataTable';
import { ReportDisplayStatus } from 'src/components/enterprise/features/Reporting/ManageReportsPage/components/ReportStatusIcon/ReportStatusIcon.utils';
import { useDownloadReport } from 'src/components/enterprise/features/Reporting/ManageReportsPage/components/ReportsTable/hooks/useDownloadReport';

export interface ReportDownloadButtonProps {
  corpId: string;
  exportId: string;
  exportName: string;
  displayStatus: ReportDisplayStatus;
}

export const ReportDownloadButton: React.FC<ReportDownloadButtonProps> = ({
  corpId,
  exportId,
  exportName,
  displayStatus,
}) => {
  const { downloadReport, isDownloading } = useDownloadReport({
    corpId,
    exportId,
  });
  const isReady = displayStatus === ReportDisplayStatus.READY;

  return (
    <DataTable.Button
      x="md"
      variant="tertiary"
      type="button"
      className="tableActionButtons"
      aria-label={`Download ${exportName}`}
      title={`Download ${exportName}`}
      disabled={!isReady || isDownloading}
      isLoading={isDownloading}
      onClick={downloadReport}
    >
      <SvgDownload size="24px" aria-hidden />
    </DataTable.Button>
  );
};
